import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Product2JP() {
    const { t } = useLang('dp3.landing.product.extra_battery');

    const items = [
        { label: t('item1_label'), value: t('item1_value') },
        { label: t('item2_label'), value: t('item2_value') },
        { label: t('item3_label'), value: t('item3_value') },
        { label: t('item4_label'), value: t('item4_value') },
        { label: t('item5_label'), value: t('item5_value') },
        { label: t('item6_label'), value: t('item6_value') },
    ];

    return (
        <div className={`page-product2JP ${styles.Product2JP} GtmModuleData-section`} data-section-id={'dp3-Product2JP'} data-section-title={t('title')}>
            <div className={`eco-content ${styles.Product2JP}`}>
                <div className="product-info">
                    <div className="extra-battery">
                        <div className="battery-bg">
                            <div className="battery-name">{t('title')}</div>
                            <div className="image-row">
                                <div className="image-item">
                                    <img src="https://websiteoss.ecoflow.com/upload/image/1750129983852/img1.png" alt={t('item1')} />
                                    <span>{t('item1')}</span>
                                </div>
                                <div className="image-item">
                                    <img src="https://websiteoss.ecoflow.com/upload/image/1750129983261/img2.png" alt={t('item2')} />
                                    <span>{t('item2')}</span>
                                </div>
                                <div className="image-item">
                                    <img src="https://websiteoss.ecoflow.com/upload/image/1750129983463/img3.png" alt={t('item3')} />
                                    <span>{t('item3')}</span>
                                </div>
                                <div className="image-item">
                                    <img src="https://websiteoss.ecoflow.com/upload/image/1750129983652/img4.png" alt={t('item4')} />
                                    <span>{t('item4')}</span>
                                </div>
                            </div>
                        </div>

                        <div className="accessories">
                            <div className="acc-item">
                                <span>{t('item5')}</span>
                                <img src="https://websiteoss.ecoflow.com/upload/image/1750129982858/img5.png" alt={t('item5')} />
                            </div>
                            <div className="acc-item">
                                <span>{t('item6')}</span>
                                <img src="https://websiteoss.ecoflow.com/upload/image/1750129983067/img6.png" alt={t('item6')} />
                            </div>
                            <div className="acc-item">
                                <span>{t('item7')}</span>
                                <img src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1718778567429/a4.png" alt={t('item7')} />
                            </div>
                        </div>

                        <div className="product-specs">
                            {items.map((item, index) => (
                                <div className="spec-item" key={index}>
                                    <span className="label">{item.label} : </span>
                                    <span className="value">{item.value}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
